import React from 'react';
import { Popover, PopoverTrigger, PopoverContent } from "@heroui/react";
import { RightPopoverSVG } from '../../drive/driveIcons';

interface DropdownPopoverProps {
  content: React.JSX.Element | string | undefined;
  isOpen: boolean;
}

const DropdownPopover: React.FC<DropdownPopoverProps> = ({
  content,
  isOpen,
}) => {
  const popoverSlotStyles = {
    popver: {
      content: '!p-0 m-0',
    },
  };
  return (
    <Popover
      placement="right"
      offset={15}
      className="w-[240px]"
      isOpen={isOpen}
      classNames={popoverSlotStyles.popver}
    >
      <PopoverTrigger>
        <div className="w-[24px] flex justify-center items-center">
          <RightPopoverSVG />
        </div>
      </PopoverTrigger>
      <PopoverContent className="shadow">{content}</PopoverContent>
    </Popover>
  );
};

export default DropdownPopover;
